import uniqid from 'uniqid'
import GitHubIcon from '@mui/icons-material/GitHub'
import LaunchIcon from '@mui/icons-material/Launch'
import VisibilityIcon from '@mui/icons-material/Visibility'


import './ProjectContainer.css'

const ProjectContainer = ({ project }) => (
  <div className='project'>
    <h3>{project.name}</h3>
    <img src={project.image} alt="logo" height={200} width={300} />
    <p className='project__description'>{project.description}</p>
    {project.stack && (
      <ul className='project__stack'>
        {project.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}

    {project.code && (
      <a
        href={project.code}
        aria-label='source code'
        className='link link--icon'
      >
        <GitHubIcon />
      </a>
    )}

    {project.preview && (
      <a
        href={project.preview}
        aria-label='preview link'
        className='link link--icon'
      >
        <VisibilityIcon />
      </a>
    )}

    {project.online && (
      <a
        href={project.online}
        aria-label='online link'
        className='link link--icon'
      >
        <LaunchIcon />
      </a>
    )}
  </div>
)

export default ProjectContainer
